import React from 'react';
import { Box, SxProps } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { colors, WHITE } from '../utils/constants';
import Navbar from './Navbar';

const AppLayout = () => {
  return (
    <Box sx={outerBoxStyles}>
      <Sidebar />
      <Box component='main' sx={mainBoxStyles}>
        {/* Fixed Navbar (no scroll) */}
        <Box position='sticky' top={0} zIndex={1100}>
          <Navbar />
        </Box>
        {/* Scrollable Content Area */}
        <Box sx={mainContentArea}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AppLayout;

const outerBoxStyles: SxProps = {
  display: 'flex',
  bgcolor: WHITE.moderate,
  height: '100%',
  boxSizing: 'border-box',
};

const mainBoxStyles: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  flexGrow: 1,
  '& .MuiMenuItem-root': {
    fontSize: '12px',
    height: 30,
    minHeight: 30,
  },
  '&::-webkit-scrollbar': {
    width: '3px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: colors.indigoBlueColor,
    borderRadius: '3px',
  },
};

const mainContentArea: SxProps = {
  flex: 1,
  overflowY: 'auto',
  '& .MuiMenuItem-root': {
    fontSize: '12px',
    height: 30,
    minHeight: 30,
  },
  '&::-webkit-scrollbar': {
    width: '3px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: colors.indigoBlueColor,
    borderRadius: '3px',
  },
};
